import {FeatureToggle} from '../../data/entities';
import {FeatureMap, FeatureName} from './types';

export const isOccupancyEnabled = (enabledFeatures: FeatureToggle[]) =>
  enabledFeatures.includes(FeatureToggle.Occupancy);

export const createMapOfEnabledFeatures = (enabledFeatures: FeatureToggle[]): FeatureMap => {
  const enabledFeaturesSet = new Set(enabledFeatures);
  const features = Object.keys(FeatureToggle) as Array<FeatureName>;

  return features.reduce(
    (prevFeature, featureName) => ({
      ...prevFeature,
      [featureName]: enabledFeaturesSet.has(FeatureToggle[featureName]),
    }),
    {},
  );
};
